import React, { FC } from 'react';
import { Loader } from 'rsuite';

export const VerificationLoading: FC = () => {
	return (
		<>
			<div className="d-flex justify-content-center mb-16 mt-18 sense-js-loader">
				<Loader size="md" />
			</div>
			<div className="text-center fw-bolder fs-6 mb-2">Connecting to your site to verify Flex installation.</div>
			<div className="text-center fs-7 text-muted">This can take up to 60 seconds.</div>

		</>
	);
};
